// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603301433/js/" + chunkId + "." + {"44":"b4077cad","225":"af494e17","481":"ecc2ea2c","486":"ee880be1","770":"f777950b"}[chunkId] + ".0.22387910918716214.chunk.js";
};